import { axiosInstance } from './axiosConfig';

export const getApplicationData = () => axiosInstance.get('application/initial_data').then((response) => response.data);
